import script from "./StoreAdminResetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreAdminResetPassword.vue?vue&type=script&setup=true&lang=js"

import "./StoreAdminResetPassword.vue?vue&type=style&index=0&id=e773077e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e773077e"]])

export default __exports__